import React from 'react';

/**
 * Office Online iframe URL. `fileUrl` must be HTTPS and fetchable by Microsoft's servers
 * (no auth cookies — they request `src` from their infrastructure).
 *
 * Use op/embed.aspx for embedded previews; op/view.aspx is the heavier full viewer UI.
 */
export function officeOnlineEmbedUrl(fileUrl: string): string {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
}

export type OfficeOnlineFilePreviewProps = {
  downloadUrl: string;
  /** Passed to iframe `title` for accessibility. */
  iframeTitle?: string;
};

/**
 * Word or Excel preview via Microsoft Office Online. Same behavior for .docx and .xlsx;
 * `downloadUrl` must be a publicly fetchable file URL.
 */
export const OfficeOnlineFilePreview: React.FC<OfficeOnlineFilePreviewProps> = ({
  downloadUrl,
  iframeTitle = 'Document preview'
}) => {
  if (!downloadUrl) {
    return null;
  }

  return (
    <div className="relative h-full w-full">
      <iframe
        src={officeOnlineEmbedUrl(downloadUrl)}
        className="h-full w-full border-0 rounded-lg"
        title={iframeTitle}
      />
    </div>
  );
};
